<template>
    <v-dialog v-model="$store.state.posting.mod" width="700">
        <v-card>
            <v-toolbar color="secondary" dense dark>
                <v-spacer></v-spacer>
                <v-card-title primary-title> Calculate MOQ </v-card-title>
                <v-spacer></v-spacer>
                <v-btn dark icon left @click="$store.state.posting.mod = false"
                    ><v-icon>mdi-close</v-icon></v-btn
                >
            </v-toolbar>
            <v-card-text>
                <v-container>
                    <v-data-table
                        :headers="headers"
                        :items="mod"
                        dense
                        hide-default-footer
                        disable-sort
                        disable-pagination
                    >
                        <template v-slot:item.TranType>
                            27
                        </template>
                        <template v-slot:item.Description>
                            Minimum Order
                        </template>

                        <template v-slot:item.ManualEntry>
                            True
                        </template>

                        <template v-slot:item.PaytranId>
                            Null
                        </template>
                        <template v-slot:item.Date>
                            {{ momt }}
                        </template>

                        <template v-slot:item.save="{ item }">
                            <v-icon
                                :disabled="dis"
                                small
                                class="mx-3"
                                color="success"
                                dark
                                @click="save(item)"
                                >mdi-plus-circle</v-icon
                            >
                        </template>
                    </v-data-table>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { mask } from 'vue-the-mask';
export default {
    props: ['Add', 'dis'],
    directives: {
        mask
    },
    data: function() {
        return {
            mod: [],
            momt: '',
            dateRules: [
                v => !!v || 'This date is required',
                v =>
                    (parseInt(v[5] + v[6]) <= 12 &&
                        parseInt(v[5] + v[6]) > 0) ||
                    'Date Incorrect',
                v =>
                    (parseInt(v[8] + v[9]) <= 31 &&
                        parseInt(v[8] + v[9]) > 0) ||
                    'Date Incorrect'
            ],
            headers: [
                { text: 'Load', value: 'LoadNum', width: '5%' },

                { text: 'LeadOrder', value: 'LeadOrder' },

                { text: 'AdjQTy', value: 'Quantity' },
                { text: 'MOQ', value: 'MOQ' },
                { text: 'mRate', value: 'Rate' },
                { text: 'Mod Charge', value: 'MOQCharge' },
                { text: 'Date', value: 'Date', width: '20%' },
                {
                    value: 'save',
                    sortable: false,
                    width: '5%'
                }
            ]
        };
    },
    mounted() {
        this.loadMod();
        this.momt = moment().format('YYYY-MM-DD h:mm:ss');
    },
    methods: {
        save: function(itm) {
            console.log(itm);
            var parms = {
                ShiftDetail: itm.ShiftDetail,
                OrderNumber: itm.LeadOrder,
                LeadOrder: itm.LeadOrder,
                Quantity: itm.MOQ,
                Rate: itm.Rate,
                Amount: itm.MOQCharge,
                TranType: 27,
                Description: 'Minimun Order',
                ManualEntry: true,
                PayTranId: null,
                TranDate: this.momt
            };
            console.log(parms);
            axios
                .post('transaction', parms)
                .then(response => {
                    console.log(response);
                    this.$store.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'saved successfully'
                    });
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        loadMod: function() {
            axios
                .get('transaction/payroll/moq/' + this.Add)
                .then(response => {
                    console.log(response.data);
                    this.mod = response.data;
                })
                .catch(function(error) {
                    console.log(error);
                });
        }
    }
};
</script>

<style></style>
